"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UIGrid(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _classNames.default)('row', className)
  }), children);
}

UIGrid.propTypes = {
  children: _react.PropTypes.node.isRequired
};
UIGrid.displayName = 'UIGrid';
var _default = UIGrid;
exports.default = _default;
module.exports = exports.default;